import React, { useContext, memo } from "react";
import styles from "./HourlyEmptyCell.module.scss";
import { ResourcePlannerContext } from "../../views/resourcePlanner/resourceMonitoring/ResourcePlannerContext";

const HourlyEmptyCell = memo(({ index }) => {
  const { detail } = useContext(ResourcePlannerContext);
  
  return (
    <div
      className={`${styles.HourlyEmptyCell_wrapper} ${
        detail?.userIndex === index ? styles.selected : styles.unSelected
      }`}
    ></div>
  );
});

HourlyEmptyCell.displayName = 'HourlyEmptyCell';

export default HourlyEmptyCell;
